export default __webpack_public_path__ + "6b7910c89a35ff87ef44645d07a17fc7.png";